import React, { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { registerPhysicalCard } from '../../services/cardService';

const RegisterCardModal = ({ visible, onClose, card, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      
      await registerPhysicalCard(card.id, values.pan);
      message.success('Card registered successfully');
      form.resetFields();
      onSuccess();
      onClose();
    } catch (error) {
      message.error(error.message || 'Failed to register card');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Register Physical Card"
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Register"
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="pan"
          label="Card PAN"
          rules={[
            { required: true, message: 'Please enter the card PAN' },
            { pattern: /^\d{16}$/, message: 'PAN must be 16 digits' }
          ]}
        >
          <Input placeholder="Enter 16-digit card number" maxLength={16} />
        </Form.Item>

        <div style={{ marginBottom: 16 }}>
          <h4>Card Details</h4>
          <p><strong>Reference:</strong> {card?.reference}</p>
          <p><strong>Amount:</strong> {card?.dest_currency_code} {card?.dest_amount}</p>
          <p><strong>Card Holder:</strong> {card?.user_name}</p>
        </div>
      </Form>
    </Modal>
  );
};

export default RegisterCardModal;
